<div style="display: flex; margin-right: 4px; height: 100%; position: relative;" data-cy="calendar-container">
  <div style="flex: 1; font-size: 12px;" data-cy="calendar-content">
    <div class="days-of-week" data-cy="calendar-weekdays-container">
      <div class="days-of-week__day"
           *ngFor="let dayOfWeek of localeDaysOfWeek; index as index"
           [title]="dayOfWeek"
           [attr.aria-label]="dayOfWeek"
           data-cy="calendar-weekday-label">
        {{localeDaysOfWeek[index]}}
      </div>
    </div>
    <div class="days-of-month" [ngClass]="'days-of-month--first-day-' + firstDayOfMonth" data-cy="calendar-days-container">
      <time class="days-of-month__day" *ngFor="let day of numDaysInSelectedMonth"
            [ngClass]="{'selected-week-day': isSelectedWeekday(day), 'hovered-week-day': isHoveredWeekday(day) && !isSelectedWeekday(day), 'highlighted-week-day': isHighlightedDay(day)}"
            (click)="changeDate(day)" (mouseover)="hoveredDayNum = day" (mouseout)="hoveredDayNum = 0"
            data-cy="calendar-day-button">
        {{day}}
      </time>
    </div>
  </div>
  <div class="mini-calendar-buttons" data-cy="calendar-controls-container">
    <div class="calendar-button" (click)="onTodayClick()" data-cy="calendar-today-button">
      <span style="position:relative; top: 3px;">Today</span>
    </div>
    <div class="calendar-button" (click)="onSelectMonthOrYear()" data-cy="calendar-year-button">
      <span style="position:relative; top: 3px;">{{selectedDate.getFullYear()}}</span>
    </div>
    <div class="calendar-button" (click)="onSelectMonthOrYear()" data-cy="calendar-month-button">
      <span style="position:relative; top: 3px;">{{getCurrentMonthName()}}</span>
    </div>
  </div>
  <div (appClickOutside)="onClickOutsideMonthYearPicker()" *ngIf="isShowMonthAndYearPicker" style="display: flex; flex-direction: column; position: absolute; width: 100%; height: 300px; background-color: white; border-radius: var(--border-radius); z-index: 2000; border: 2px solid var(--tdo-primary); right: 0;" data-cy="calendar-picker-popup">
    <div style="flex-basis: fit-content; margin-left: 2px; color: var(--tdo-secondary); font-weight: 500;" data-cy="calendar-months-label">Months</div>
    <div style="flex: 1; display: flex; flex-wrap: wrap; padding: 3px; overflow-y: auto; justify-content: space-around;" data-cy="calendar-months-container">
      <div *ngFor="let month of months; let i = index;" (click)="onMonthClick(i)" style="width: 30%; text-align: center;" class="month-year-popup-item" [ngClass]="{'month-year-popup-item-selected': isSelectedMonth(i)}" data-cy="calendar-month-option">{{month}}</div>
    </div>
    <div style="flex-basis: 10px;"></div>
    <div style="flex-basis: fit-content; margin-left: 2px; color: var(--tdo-secondary); font-weight: 500;" data-cy="calendar-years-label">Years</div>
    <div style="flex: 1; display: flex; flex-wrap: wrap; padding: 3px; overflow-y: auto; justify-content: space-around;" data-cy="calendar-years-container">
      <div *ngFor="let year of years" (click)="onYearClick(year)" style="width: 30%; text-align: center;" class="month-year-popup-item" [ngClass]="{'month-year-popup-item-selected': isSelectedYear(year)}" data-cy="calendar-year-option">{{year}}</div>
    </div>
  </div>
</div>
